import { Skills } from '@/components/sections/skills';

export function SkillsPage() {
  return (
    <div className="container">
      <Skills />
    </div>
  );
}